export default function auth ({ to, next, store }){
 if(!store.getters.loggedIn){
     return next({
        name: 'Login',
        query: { return_url: to.fullPath }
     })
 }

 return next()
}